import { Partner, ProfileTypes, User } from "..";

export interface Header {
    id: string;
    name: string;
    partner: Partner.Header;
}

export interface Site extends Header {
    profile: Profile;
    nature: Nature;
    assignedPartnerUsers: {partnerUser: User.Header, role: PartnerUserRole}[];
    inviteCode: string;
}

export enum Nature { 
    "Virtual" = "VIRTUAL",
    "Physical" = "PHYSICAL",
}

export interface Profile {
    phone: string;
    address: ProfileTypes.Address;
}

export enum PartnerUserRole { 
    MANAGER = <any>"MANAGER",
    CASEWORKER = <any>"CASEWORKER",
}